import { defineComponent as _defineComponent } from 'vue'
import IconPrinter from '@white-label-icon/icon-printer';

import { print } from '@white-label-helper/print';

interface PrintReceiptButtonProps {
  id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'print-receipt-button',
  props: {
    id: { default: '' }
  },
  setup(__props: any) {



function printReceipt() {
  print();
}

return { __sfc: true,printReceipt, IconPrinter }
}

})